import { IconBrandLinkedin, IconBrandX, IconBrandFacebook } from "@tabler/icons-react";

type Props = {
  title: string;
  url: string;
};

export default function SocialShare({ title, url }: Props) {
  const shareLinks = [
    {
      name: "LinkedIn",
      icon: IconBrandLinkedin,
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
      iconSize: 22,
      stroke: 1.8,
      hoverClass: "hover:text-[#0A66C2]",
    },
    {
      name: "X (Twitter)",
      icon: IconBrandX,
      href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`,
      iconSize: 21,
      stroke: 1.9,
      hoverClass: "hover:text-black",
    },
    {
      name: "Facebook",
      icon: IconBrandFacebook,
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      iconSize: 23,
      stroke: 1.9,
      hoverClass: "hover:text-[#1877F2]",
    },
  ];

  return (
    <div className="flex items-center gap-2.5">
      <span className="mr-0.5 text-sm font-semibold leading-none text-gray-600">Share:</span>

      {shareLinks.map((link) => {
        const Icon = link.icon;

        return (
          <a
            key={link.name}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Share on ${link.name}`}
            title={`Share on ${link.name}`}
            className={`inline-flex h-11 w-11 items-center justify-center rounded-xl border border-gray-200 bg-gray-50 text-gray-600 transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-300 hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-400 focus-visible:ring-offset-2 ${link.hoverClass}`}
          >
            <Icon size={link.iconSize} stroke={link.stroke} aria-hidden="true" />
          </a>
        );
      })}
    </div>
  );
}
